module.exports = {"audiences":["upNextMembers"],"experimentAllocation":{"upNextMembers":1},"defaultWeight":0,"experimentVersion":"v1","defaults":{"enabled":false},"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}],"autoTrack":true}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/upNext.json
// module id = NKj6
// module chunks = 0